// NOTE:
// When we receive an updated spreadsheet from Squarespace,
// some finessing of the data is required. It's not copy/paste.
//
// See instructions below.
export const ADS = [
    {
        // NOTE:
        // Download the asset from the "link to asset" column.
        // Rename asset to something sensible.
        // Optimize image. I used the following settings:
        //   JPG w/ 1092px wide, 80% quality, and stripped meta-data
        // For performance, place images in:
        //   nginx/public/ads/
        // To test images locally, use:
        //   ```
        //   docker compose down
        //   docker compose build nginx
        //   docker compose up
        //   ```
        img: "/ads/squarespace-1.jpg",

        // NOTE:
        // Find value in "Impression Tag (Javascript)" column.
        // Grab only the script src URL and ignore the rest.
        // Clean the URL via:
        // - Replace `;ltd=?` with `;ltd=`, and make sure it's at the end of URL
        // - Delete `;ord=[timestamp]`
        // - Delete `${GDPR}`
        // - Delete `${GDPR_CONSENT_755}`
        //
        // Example:
        // - URL provided by Squarespace:
        //   https://ad.doubleclick.net/ddm/trackimpi/N718679.3040413THENOUNPROJECT.CO/B29332811.360309386;dc_trk_aid=551331108;dc_trk_cid=187188328;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=?
        //
        // - URL becomes:
        //   https://ad.doubleclick.net/ddm/trackimpi/N718679.3040413THENOUNPROJECT.CO/B29332811.360309386;dc_trk_aid=551331108;dc_trk_cid=187188328;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=;gdpr_consent=;ltd=
        impression:
            "https://ad.doubleclick.net/ddm/trackimpj/N718679.3040413THENOUNPROJECT.CO/B29332811.360309386;dc_trk_aid=551331108;dc_trk_cid=187188328;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=;gdpr_consent=;ltd=",

        // NOTE:
        // Find value in "Click Tag" column.
        // Make sure link ends in `;ltd=`
        click:
            "https://ad.doubleclick.net/ddm/trackclk/N718679.3040413THENOUNPROJECT.CO/B29332811.360309386;dc_trk_aid=551331108;dc_trk_cid=187188328;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd="
    },
    {
        img: "/ads/squarespace-2.jpg",
        impression:
            "https://ad.doubleclick.net/ddm/trackimpj/N718679.3040413THENOUNPROJECT.CO/B29332811.360309632;dc_trk_aid=551477134;dc_trk_cid=187188328;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=;gdpr_consent=;ltd=",
        click:
            "https://ad.doubleclick.net/ddm/trackclk/N718679.3040413THENOUNPROJECT.CO/B29332811.360309632;dc_trk_aid=551477134;dc_trk_cid=187188328;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd="
    },
    {
        img: "/ads/squarespace-3.jpg",
        impression:
            "https://ad.doubleclick.net/ddm/trackimpj/N718679.3040413THENOUNPROJECT.CO/B29332811.360685014;dc_trk_aid=551477140;dc_trk_cid=187188328;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=;gdpr_consent=;ltd=",
        click:
            "https://ad.doubleclick.net/ddm/trackclk/N718679.3040413THENOUNPROJECT.CO/B29332811.360685014;dc_trk_aid=551477140;dc_trk_cid=187188328;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd="
    }
];
